import { QueryClientProvider } from '@tanstack/react-query'
import 'simplebar-react/dist/simplebar.min.css'

import './styles/route-view-transitions.css'
import { type ReactNode, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { TechnicalError } from '@orus.eu/error'

import { App } from './app.tsx'
import { TRPCProvider, trpcClient_DO_NOT_USE_ONLY_FOR_TANSTACK_QUERY_PROVIDER } from './client.ts'
import { DevTools } from './dev-tools.tsx'
import { LazyPostHogProvider } from './lib/lazy-post-hog-provider.tsx'
import { logger } from './lib/logger.ts'
import { loadTally } from './lib/tally-util.ts'
import { queryClient } from './shared/query-client.ts'

const container = document.getElementById('react-root')
if (!container) {
  throw new TechnicalError('Element with id "react-root" not found')
}

const root = createRoot(container)
const rootReactNote: ReactNode = (
  <StrictMode>
    <LazyPostHogProvider>
      <QueryClientProvider client={queryClient}>
        <TRPCProvider trpcClient={trpcClient_DO_NOT_USE_ONLY_FOR_TANSTACK_QUERY_PROVIDER} queryClient={queryClient}>
          <App />
          <DevTools />
        </TRPCProvider>
      </QueryClientProvider>
    </LazyPostHogProvider>
  </StrictMode>
)

root.render(rootReactNote)
void loadTally()

import('./lib/sentry-integration.ts')
  .then(({ ensureSentryIsInitialized }) => {
    ensureSentryIsInitialized()
  })
  .catch(() => {
    logger.warning('Sentry initialization failed')
  })
// console.log('🔧 Vite build vars:', { __ORUS_LOCAL_DEV_ENABLE_TRACKING__ })
